module.exports = __webpack_public_path__ + "img/aboutUsBg-1.eb9ef227.png";